// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Division from "../../components/Division"
import * as strings from "../../strings"
import Dropdown from "react-toolbox/lib/dropdown"
import Input from "react-toolbox/lib/input/Input"
import Dialog from "react-toolbox/lib/dialog"
import Checkbox from "react-toolbox/lib/checkbox"
import Autocomplete from "react-toolbox/lib/autocomplete"
import DatePicker from "../../components/DatePicker"
import _ from "lodash"
import { connect } from "react-redux"

const STATE_LITIGATION_TYPE = 1
const STATE_EXECUTION_TYPE = 2
const STATE_PRELITIGATION_TYPE = 3

const CIVIL_TYPE = 1
const INSOLVENCY_TYPE = 2
const PER_TYPE = 3
const INSOLVENCY_SUBTYPE = 3
const PER_SUBTYPE = 4
const EXECUTION_SUBTYPE_IDS = [ 5, 6, 7 ]

class DebtPhaseOptions extends Component {
  props: {
    debtPhaseEnum: string,
    debtPhase: any,
    debt: any,
    debtPhaseId: number,
    isExecution: boolean,
    onChange: () => any,
    parentOption: any,

    types: any[],
    subtypes: any[],
    conclusionReasons: any[],
    states: any[],
  }

  state = {
    options: undefined,
    toExecutionDialog: false,
    errorDialog: false,
    selectedIds: [],
    lastSubType: undefined,
    lastType: undefined,
  }

  formatOptions = ( optionArray ) => {
    return _.chain( optionArray )
      .map( option => ( { value: option.id, label: option.name } ) )
      .orderBy( [ "label" ], [ "desc" ] )
      .value()
  }

  debtPhaseTypeId = () => {
    if (this.props.debtPhaseEnum === "PreLitigation") {
      return STATE_PRELITIGATION_TYPE;
    } else if (this.props.debtPhaseEnum === "Litigation") {
      return STATE_LITIGATION_TYPE;
    } else {
      return STATE_EXECUTION_TYPE;
    }
  }

  formattedOption = () => {
    if ( !this.props.parentOption ) {
      return {}
    }

    const { idType, idState, idConclusionReason, idSubtype } = this.props.parentOption

    return {
      ...this.props.parentOption,
      type: _.find( this.props.types, { id: idType } ),
      subtype: _.find( this.props.subtypes, { id: idSubtype } ),
      conclusionReason: _.find( this.props.conclusionReasons, { id: idConclusionReason } ),
      state: _.find( this.props.states, {
        id: idState,
        type: this.debtPhaseTypeId(),
      } ),
    }
  }

  /* ***************************************************************************
*                             Handlers & Utils
*******************************************************************************/

  handleSubtypeChange = ( subTypeId ) => {
    const subType = _.find( this.props.subtypes, { id: subTypeId } )

    let type
    let toExecutionDialog
    let errorDialog

    // This verification is needed since subtype choice influences type
    if ( subTypeId === INSOLVENCY_SUBTYPE ) {
      type = INSOLVENCY_TYPE
    } else if ( subTypeId === PER_SUBTYPE ) {
      type = PER_TYPE
    } else if ( _.includes( EXECUTION_SUBTYPE_IDS, subTypeId ) ) {

      const filteredPaymentAgreements = _.compact( this.props.debt.paymentAgreements.map(
        paymentAgreement =>
          paymentAgreement.status === "Frustrated" ||
          paymentAgreement.status === "FinishedUnsuccessfully" ||
          paymentAgreement.status === "Draft" ||
          paymentAgreement.status === "FinishedSuccessfully"
      ) )
      const canProceedToExecution = filteredPaymentAgreements.length === this.props.debt.paymentAgreements.length

      toExecutionDialog = this.props.debtPhaseEnum === "Litigation" && canProceedToExecution;
      errorDialog = this.props.debtPhaseEnum === "Litigation" && !canProceedToExecution;
      type = CIVIL_TYPE
    } else {
      type = CIVIL_TYPE
    }

    this.setState( {
      lastSubType: this.props.parentOption ? this.props.parentOption.idSubtype : undefined,
      lastType: this.props.parentOption ? this.props.parentOption.idType : undefined,
      toExecutionDialog,
      errorDialog,
      selectedIds: _.includes( EXECUTION_SUBTYPE_IDS, subTypeId ) &&
       toExecutionDialog ? [ this.props.debtPhaseId ] : [],
    } )

    this.props.onChange( {
      idType: type,
      idSubtype: subTypeId,
    } )
  }

  handleStateChange = ( idState ) => {
    // In case the state changed to these two states, it cleans the possible filled vars
    if ( !this.isFindo() && !this.isWaitJudgement() ) {

      this.props.onChange( { idState }, {
        judgementDay: "",
        judgementHour: "",
        witnessName: "",
        testimonyType: "",
      } )

      return
    }

    this.props.onChange( {
      idState,
    } )
  }

  isFindo = () => {
    const formattedOption = this.formattedOption()
    const stateName = _.get( formattedOption, "state.name", "" )
    return stateName.startsWith( "Findo" )
  }

  isWaitJudgement = () => {
    const formattedOption = this.formattedOption()
    const stateName = _.get( formattedOption, "state.name", "" )
    return stateName === "Aguarda julgamento"
  }

  handleToggle = () => {
    this.props.onChange( {
      idSubtype: this.state.lastSubType,
      idType: this.state.lastType,
    } )
    this.setState( {
      toExecutionDialog: !this.state.toExecutionDialog,
      selectedIds: this.state.toExecutionDialog ? [] : this.state.selectedIds,
    } )
  }

  handleToggleDialog = () => {
    this.props.onChange( {
      idToExecution: [ ...this.state.selectedIds ],
    } )
    this.setState( {
      toExecutionDialog: !this.state.toExecutionDialog,
    } )
  }

  handleErrorDialog = () => {
    this.props.onChange( {
      idSubtype: this.state.lastSubType,
      idType: this.state.lastType,
    } )
    this.setState( {
      errorDialog: !this.state.errorDialog,
    } )
  }

  selectAll = () => {
    let newSelectedIds = _.isEqual( this.props.debt.litigations.length, this.state.selectedIds.length ) ? []
      : this.props.debt.litigations.map( litigation => litigation.id )
    return this.setState( {
      selectedIds: newSelectedIds,
    } )
  }

  selectOne = ( debtPhaseId ) => {
    let newSelectedIds = this.state.selectedIds.includes( debtPhaseId ) ?
      this.state.selectedIds.filter( id => id !== debtPhaseId )
      : [ ...this.state.selectedIds, debtPhaseId ]
    return this.setState( {
      selectedIds: newSelectedIds,
    } )
  }

  /** **************************************************************************
   *                             Renders
   *******************************************************************************/

  renderPartial = () => {
    const formattedOption = this.formattedOption()
    const stateName = _.get( formattedOption, "state.name", "" )

    if ( stateName !== "Findo parcial" ) {
      return null
    }

    return (
      <Input
        label="Valor recuperado"
        value={this.props.debtPhase.recoveredValue}
        onChange={value => this.props.onChange( {}, { recoveredValue: value } )}
        type="number"
        step="0.01"
        min="0.00"
        icon="euro_symbol"
      />
    )
  }

  renderConclusionReason = ( formattedOptions ) => {
    const { generalStrings } = strings
    if ( !this.isFindo() ) {
      return null
    }

    return (
      <Dropdown
        auto
        onChange={ value => this.props.onChange( { idConclusionReason: value } )}
        source={formattedOptions.conclusionReasons}
        value={_.get( this, "props.parentOption.idConclusionReason" )}
        label={generalStrings.conclusionMotive}
      />
    )
  }


  renderInsolvency = () => {
    const { debtPhase } = this.props
    const insolvencyLike = [ PER_SUBTYPE, INSOLVENCY_SUBTYPE ]
    if ( !insolvencyLike.includes( _.get( this.props, "parentOption.idSubtype" ) ) ) {
      return null
    }

    const courtSource = _.get( this.props, "courts", [] )
      .reduce( ( acc, court ) => ( {
        ...acc,
        [ court.id ]: court.name,
      } ), {} )


    return (
      <div className={style.insolvency}>
        <DatePicker
          icon="date_range"
          label="Data de inicio de insolvência"
          onChange={value => this.props.onChange( {}, { insolvencyStartDate: value } )}
          value={debtPhase.insolvencyStartDate}
          className={style.insolvencyDatePicker}
        />
        <Input
          label="IDC de insolvência"
          value={debtPhase.insolvencyIdc}
          onChange={value => this.props.onChange( {}, { insolvencyIdc: value } )}
        />
        <Input
          label="N° Processo de insolvência"
          value={debtPhase.insolvencyProcessNumber}
          onChange={value => this.props.onChange( {}, { insolvencyProcessNumber: value } )}
        />

        <Autocomplete
          showSuggestionsWhenValueIsSet={true}
          direction="down"
          multiple={false}
          label="Tribunal de insolvência"
          source={courtSource}
          value={debtPhase.idCourtInsolvency}
          onChange={value => this.props.onChange( {}, { idCourtInsolvency: _.parseInt( value ) } ) }
        />
        <Input
          label="Juízo / Serviço"
          value={debtPhase.insolvencyService}
          onChange={value => this.props.onChange( {}, { insolvencyService: value } )}
        />
        <Input
          label={strings.paymentAgreements.section}
          value={debtPhase.insolvencySection}
          onChange={value => this.props.onChange( {}, { insolvencySection: value } )}
        />
      </div>
    )
  }

  renderIsWaitingJudgement = () => {
    const { generalStrings } = strings
    if ( !this.isWaitJudgement() ) {
      return null
    }

    return (
      <div className={style.isWaitingJudgement}>
        <Input
          label={generalStrings.witnessName}
          value={this.props.debtPhase.witnessName}
          onChange={value => this.props.onChange( {}, { witnessName: value } )}
        />
        <Input
          label={generalStrings.judgementDay}
          value={ this.props.debtPhase.judgementDay}
          onChange={value => this.props.onChange( {}, { judgementDay: value } )}
        />
        <Input
          label={generalStrings.judgementHour}
          value={this.props.debtPhase.judgementHour}
          onChange={value => this.props.onChange( {}, { judgementHour: value } )}
        />
        <Autocomplete
          direction="down"
          showSuggestionsWhenValueIsSet={true}
          allowCreate={true}
          multiple={false}
          label={generalStrings.testimonyType}
          value={this.props.debtPhase.testimonyType}
          onChange={value => this.props.onChange( {}, { testimonyType: value } )}
          source={[ "PRESENCIAL", "ESCRITO", "D.E" ]}
        />
      </div>
    )
  }

  renderDialogInformation = () => {

    if ( this.props.debt.length === 0 ) {
      return <div/>
    }

    return ( <div className={style.insideDialog}>
      <div className={style.blueHeader}/>
      <Division title={strings.processes.injunctions.toUpperCase()}/>
      <div className={style.toExecutionText}>{strings.generalStrings.ifYouWishTransitAdicionalInjunctions}</div>
      <table className={style.tableCss}>
        <thead>
          <tr>
            <th className={style.checkBoxFix}>
              <Checkbox
                checked={_.isEqual( this.props.debt.litigations.length, this.state.selectedIds.length )}
                onChange={() => this.selectAll()}
              />
            </th>
            <th className={style.tableTitle}><b>{strings.processes.injunctionNumber}</b></th>
            <th className={style.tableTitle}><b>{strings.generalStrings.caseId}</b></th>
            <th className={style.tableTitle}><b>{strings.generalStrings.segment}</b></th>
          </tr>
        </thead>
        <tbody>
          {this.props.debt.litigations.map( ( litigation, i ) =>
            <tr key={i}>
              <td className={style.checkBoxFix}>
                <Checkbox
                  checked={this.state.selectedIds.includes( litigation.id )}
                  onChange={ () => this.selectOne( litigation.id )}
                />
              </td>
              <td className={style.tdTitle}>{litigation.injunctionNumber}</td>
              <td className={style.tdTitle}>{litigation.idc}</td>
              <td className={style.tdTitle}>{litigation.segment || "Sem segmento"}</td>
            </tr> )}
        </tbody>
      </table>
    </div> )
  }

  renderErrorInformation = () => {
    return (
      <div className={style.insideDialog}>
        <div className={style.blueHeader}/>
        <Division title={strings.generalStrings.categorisation.toUpperCase()}/>
        <div className={style.text}>
          {strings.generalStrings.thereArentFrustraedOrUnfinishedPaymentAgreements}
          <p>{strings.generalStrings.ruleToExecutionOne}</p>
          <p>{strings.generalStrings.ruleToExecutionTwo}</p>
          <p></p>
        </div>
      </div>
    )
  }

  render () {
    if ( !this.props.debt || !this.props.parentOption ) {
      return null
    }

    const { generalStrings } = strings
    const formattedOptions = {
      subTypes: this.formatOptions( this.props.subtypes ),
      types: this.formatOptions( this.props.types ),
      conclusionReasons: this.formatOptions( this.props.conclusionReasons ),
      states: this.formatOptions(
        _.filter( this.props.states, {
          type: this.debtPhaseTypeId()
        } )
      ),
    }


    return (
      <div className={style.optionsContainer}>
        <Dialog
          className={style.dialogBoxFormat}
          actions={[
            { label: strings.generalStrings.cancel, onClick: this.handleToggle },
            { label: strings.generalStrings.submit, onClick: this.handleToggleDialog },
          ]}
          active={this.state.toExecutionDialog}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
        >
          {this.renderDialogInformation()}
        </Dialog>
        <Dialog
          className={style.dialogBoxFormat}
          actions={[
            { label: strings.generalStrings.ok, onClick: this.handleErrorDialog },
          ]}
          active={this.state.errorDialog}
          onEscKeyDown={this.handleErrorDialog}
          onOverlayClick={this.handleErrorDialog}
        >
          {this.renderErrorInformation()}
        </Dialog>
        <div className={style.blueBar}/>
        <div className={style.categorisation}>
          <Division title={strings.generalStrings.categorisation.toUpperCase()}/>
          <div className={!this.isFindo() ? style.optionFields : style.findoOptionFields}>
            <Dropdown
              disabled
              auto
              source={this.formatOptions( this.props.types )}
              value={_.get( this, "props.parentOption.idType" )}
              label={generalStrings.type}
            />
            <Dropdown
              disabled={this.props.debtPhaseEnum === "PreLitigation"}
              auto
              onChange={ value => this.handleSubtypeChange( value )}
              source={formattedOptions.subTypes}
              value={_.get( this, "props.parentOption.idSubtype" )}
              label={generalStrings.subType}
            />
            <Dropdown
              auto
              onChange={ value => this.handleStateChange( value )}
              source={formattedOptions.states}
              value={_.get( this, "props.parentOption.idState" )}
              label={generalStrings.state}
            />
            {this.renderInsolvency()}
            {this.renderIsWaitingJudgement()}
            {this.renderConclusionReason( formattedOptions )}
            {this.renderPartial()}
          </div>
        </div>
      </div>
    )
  }
}



export default connect( store => ( {
  courts: _.get( store, "suggestions.courts", [] ),
  types: _.get( store, "suggestions.types", [] ),
  subtypes: _.get( store, "suggestions.subtypes", [] ),
  conclusionReasons: _.get( store, "suggestions.conclusionReasons", [] ),
  states: _.get( store, "suggestions.states", [] ),
} ) )( DebtPhaseOptions )



// WEBPACK FOOTER //
// ./src/components/DebtPhaseOptions/index.jsx